// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"453":"03b570a5","724":"97d0e6c1","753":"526eea2a"}[chunkId] + ".chunk.js";
};